import ICitizenVm from "../models/shared/ICitizenVm"
import * as ICitizenVmInstance from "../models/shared/ICitizenVm"
import IApplicationVm from "../models/shared/IApplicationVm"
import IHomeVm from "../models/home/Home/IHomeVm"
import * as IHomeVmInstance from "../models/home/Home/IHomeVm"
import IEducationalInstitutionContextVm from "../models/educationalInstitution/IEducationalInstitutionContextVm"
import * as IEducationalInstitutionContextVmInstance from "../models/educationalInstitution/IEducationalInstitutionContextVm"
import { IMeta } from "../reducers/metaReducer"
import IUserVm from "../models/shared/IUserVm"
import * as IUserVmInstance from "../models/shared/IUserVm"
import ICaseworkerContextVm from "../models/issuingAuthority/ICaseworkerContextVm"
import * as ICaseworkerContextVmInstance from "../models/issuingAuthority/ICaseworkerContextVm"
import IInvoiceVm from "../models/home/Payment/IInvoiceVm"
import * as IInvoiceVmInstance from "../models/home/Payment/IInvoiceVm"
import ICompanyVm from "../models/shared/ICompanyVm"
import * as ICompanyVmInstance from "../models/shared/ICompanyVm"
import ICreateApplicationForExemptedCitizenVm from "../models/issuingAuthority/ICreateApplicationForExemptedCitizenVm"
import * as ICreateApplicationForExemptedCitizenVmInstance from "../models/issuingAuthority/ICreateApplicationForExemptedCitizenVm"
import ICreateApplicationForReorderingOfCertificateVm from "../models/issuingAuthority/ICreateApplicationForReorderingOfCertificateVm"
import * as ICreateApplicationForReorderingOfCertificateVmInstance from "../models/issuingAuthority/ICreateApplicationForReorderingOfCertificateVm"
import ITeamVm from "../models/shared/ITeamVm"
import * as  ITeamVmInstance from "../models/shared/ITeamVm"
import * as IErrorCaseVmInstance from "../models/issuingAuthority/IErrorCaseVm"
import IErrorCaseVm from "../models/issuingAuthority/IErrorCaseVm"
import ICommentVm from "../models/shared/ICommentVm"
import * as IAddressVmInstance from "../models/shared/IAddressVm"
import * as ICommentVmInstance from "../models/shared/ICommentVm"

export default class InitState {
    public application: IApplicationVm
    public applicationForExempted: ICreateApplicationForExemptedCitizenVm = {...ICreateApplicationForExemptedCitizenVmInstance.empty(), secondaryDeliveryAddress: { ...IAddressVmInstance.empty(), id: Math.random().toString() }}
    public applicationForReorderingOfCertificate: ICreateApplicationForReorderingOfCertificateVm = { ...ICreateApplicationForReorderingOfCertificateVmInstance.empty(), modifiedAddress: { ...IAddressVmInstance.empty(), id: Math.random().toString() } }
    public applications: IApplicationVm[] = []
    public caseworker: ICaseworkerContextVm = ICaseworkerContextVmInstance.empty()
    public citizen: ICitizenVm = ICitizenVmInstance.empty()
    public educationalInstitution: IEducationalInstitutionContextVm = IEducationalInstitutionContextVmInstance.empty()
    public errorCase: IErrorCaseVm = IErrorCaseVmInstance.empty()
    public errorCases: IErrorCaseVm[] = []
    public company: ICompanyVm = ICompanyVmInstance.empty()
    public companies: ICompanyVm[] = []
    public comment: ICommentVm = ICommentVmInstance.empty()
    public home: IHomeVm = IHomeVmInstance.empty()
    public invoice: IInvoiceVm = IInvoiceVmInstance.empty()
    public meta: IMeta
    public teams: ITeamVm[] = []
    public team: ITeamVm = ITeamVmInstance.empty()
    public user: IUserVm = IUserVmInstance.empty()
}
